import { CheckCircleOutlined, ClockCircleOutlined, CloseCircleOutlined } from "@ant-design/icons-vue";
import { IconType } from "@ant-design/icons-vue/lib/components/Icon";

export enum ReferredStatus {
  Pending = 1,
  Earned = 2,
  Lost = 3,
}

export const ReferredStatusText: Record<ReferredStatus, string> = {
  [ReferredStatus.Pending]: "Pendiente",
  [ReferredStatus.Earned]: "Ganado",
  [ReferredStatus.Lost]: "Perdido",
};

export const ReferredStatusColor: Record<ReferredStatus, string> = {
  [ReferredStatus.Pending]: "default",
  [ReferredStatus.Earned]: "green",
  [ReferredStatus.Lost]: "red",
};

export const ReferredStatusIcon: Record<ReferredStatus, IconType> = {
  [ReferredStatus.Pending]: ClockCircleOutlined,
  [ReferredStatus.Earned]: CheckCircleOutlined,
  [ReferredStatus.Lost]: CloseCircleOutlined,
};